/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface EnteringTheBoxDifference {
  accommodationDiff?: AccommodationDifferences;
  priceDiff?: PriceDifference;
  tourOperatorDiff?: TourOperatorDifference;
}

export interface AccommodationDifferences {
  transfer: AccommodationDifferences_Status;
  privateTransfer: AccommodationDifferences_Status;
  railAndFly: AccommodationDifferences_Status;
}

export enum AccommodationDifferences_Status {
  NoChange = "NoChange",
  Removed = "Removed",
  Added = "Added",
}

export function accommodationDifferences_StatusFromJSON(
  object: any
): AccommodationDifferences_Status {
  switch (object) {
    case 0:
    case "NoChange":
      return AccommodationDifferences_Status.NoChange;
    case 1:
    case "Removed":
      return AccommodationDifferences_Status.Removed;
    case 2:
    case "Added":
      return AccommodationDifferences_Status.Added;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum AccommodationDifferences_Status"
      );
  }
}

export function accommodationDifferences_StatusToJSON(
  object: AccommodationDifferences_Status
): string {
  switch (object) {
    case AccommodationDifferences_Status.NoChange:
      return "NoChange";
    case AccommodationDifferences_Status.Removed:
      return "Removed";
    case AccommodationDifferences_Status.Added:
      return "Added";
    default:
      return "UNKNOWN";
  }
}

export function accommodationDifferences_StatusToNumber(
  object: AccommodationDifferences_Status
): number {
  switch (object) {
    case AccommodationDifferences_Status.NoChange:
      return 0;
    case AccommodationDifferences_Status.Removed:
      return 1;
    case AccommodationDifferences_Status.Added:
      return 2;
    default:
      return 0;
  }
}

export interface PriceDifference {
  difference: number;
  relativeDifferencePercentage: number;
}

export interface TourOperatorDifference {
  oldTourOperator: string;
  newTourOperator: string;
}

function createBaseEnteringTheBoxDifference(): EnteringTheBoxDifference {
  return {
    accommodationDiff: undefined,
    priceDiff: undefined,
    tourOperatorDiff: undefined,
  };
}

export const EnteringTheBoxDifference = {
  encode(
    message: EnteringTheBoxDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.accommodationDiff !== undefined) {
      AccommodationDifferences.encode(
        message.accommodationDiff,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.priceDiff !== undefined) {
      PriceDifference.encode(
        message.priceDiff,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.tourOperatorDiff !== undefined) {
      TourOperatorDifference.encode(
        message.tourOperatorDiff,
        writer.uint32(26).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): EnteringTheBoxDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnteringTheBoxDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.accommodationDiff = AccommodationDifferences.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.priceDiff = PriceDifference.decode(reader, reader.uint32());
          break;
        case 3:
          message.tourOperatorDiff = TourOperatorDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): EnteringTheBoxDifference {
    return {
      accommodationDiff: isSet(object.accommodationDiff)
        ? AccommodationDifferences.fromJSON(object.accommodationDiff)
        : undefined,
      priceDiff: isSet(object.priceDiff)
        ? PriceDifference.fromJSON(object.priceDiff)
        : undefined,
      tourOperatorDiff: isSet(object.tourOperatorDiff)
        ? TourOperatorDifference.fromJSON(object.tourOperatorDiff)
        : undefined,
    };
  },

  toJSON(message: EnteringTheBoxDifference): unknown {
    const obj: any = {};
    message.accommodationDiff !== undefined &&
      (obj.accommodationDiff = message.accommodationDiff
        ? AccommodationDifferences.toJSON(message.accommodationDiff)
        : undefined);
    message.priceDiff !== undefined &&
      (obj.priceDiff = message.priceDiff
        ? PriceDifference.toJSON(message.priceDiff)
        : undefined);
    message.tourOperatorDiff !== undefined &&
      (obj.tourOperatorDiff = message.tourOperatorDiff
        ? TourOperatorDifference.toJSON(message.tourOperatorDiff)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<EnteringTheBoxDifference>
  ): EnteringTheBoxDifference {
    const message = createBaseEnteringTheBoxDifference();
    message.accommodationDiff =
      object.accommodationDiff !== undefined &&
      object.accommodationDiff !== null
        ? AccommodationDifferences.fromPartial(object.accommodationDiff)
        : undefined;
    message.priceDiff =
      object.priceDiff !== undefined && object.priceDiff !== null
        ? PriceDifference.fromPartial(object.priceDiff)
        : undefined;
    message.tourOperatorDiff =
      object.tourOperatorDiff !== undefined && object.tourOperatorDiff !== null
        ? TourOperatorDifference.fromPartial(object.tourOperatorDiff)
        : undefined;
    return message;
  },
};

function createBaseAccommodationDifferences(): AccommodationDifferences {
  return {
    transfer: AccommodationDifferences_Status.NoChange,
    privateTransfer: AccommodationDifferences_Status.NoChange,
    railAndFly: AccommodationDifferences_Status.NoChange,
  };
}

export const AccommodationDifferences = {
  encode(
    message: AccommodationDifferences,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.transfer !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(8)
        .int32(accommodationDifferences_StatusToNumber(message.transfer));
    }
    if (message.privateTransfer !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(16)
        .int32(
          accommodationDifferences_StatusToNumber(message.privateTransfer)
        );
    }
    if (message.railAndFly !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(24)
        .int32(accommodationDifferences_StatusToNumber(message.railAndFly));
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationDifferences {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationDifferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.transfer = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        case 2:
          message.privateTransfer = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        case 3:
          message.railAndFly = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationDifferences {
    return {
      transfer: isSet(object.transfer)
        ? accommodationDifferences_StatusFromJSON(object.transfer)
        : AccommodationDifferences_Status.NoChange,
      privateTransfer: isSet(object.privateTransfer)
        ? accommodationDifferences_StatusFromJSON(object.privateTransfer)
        : AccommodationDifferences_Status.NoChange,
      railAndFly: isSet(object.railAndFly)
        ? accommodationDifferences_StatusFromJSON(object.railAndFly)
        : AccommodationDifferences_Status.NoChange,
    };
  },

  toJSON(message: AccommodationDifferences): unknown {
    const obj: any = {};
    message.transfer !== undefined &&
      (obj.transfer = accommodationDifferences_StatusToJSON(message.transfer));
    message.privateTransfer !== undefined &&
      (obj.privateTransfer = accommodationDifferences_StatusToJSON(
        message.privateTransfer
      ));
    message.railAndFly !== undefined &&
      (obj.railAndFly = accommodationDifferences_StatusToJSON(
        message.railAndFly
      ));
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationDifferences>
  ): AccommodationDifferences {
    const message = createBaseAccommodationDifferences();
    message.transfer =
      object.transfer ?? AccommodationDifferences_Status.NoChange;
    message.privateTransfer =
      object.privateTransfer ?? AccommodationDifferences_Status.NoChange;
    message.railAndFly =
      object.railAndFly ?? AccommodationDifferences_Status.NoChange;
    return message;
  },
};

function createBasePriceDifference(): PriceDifference {
  return { difference: 0, relativeDifferencePercentage: 0 };
}

export const PriceDifference = {
  encode(
    message: PriceDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.difference !== 0) {
      writer.uint32(13).float(message.difference);
    }
    if (message.relativeDifferencePercentage !== 0) {
      writer.uint32(21).float(message.relativeDifferencePercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.difference = reader.float();
          break;
        case 2:
          message.relativeDifferencePercentage = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceDifference {
    return {
      difference: isSet(object.difference) ? Number(object.difference) : 0,
      relativeDifferencePercentage: isSet(object.relativeDifferencePercentage)
        ? Number(object.relativeDifferencePercentage)
        : 0,
    };
  },

  toJSON(message: PriceDifference): unknown {
    const obj: any = {};
    message.difference !== undefined && (obj.difference = message.difference);
    message.relativeDifferencePercentage !== undefined &&
      (obj.relativeDifferencePercentage = message.relativeDifferencePercentage);
    return obj;
  },

  fromPartial(object: DeepPartial<PriceDifference>): PriceDifference {
    const message = createBasePriceDifference();
    message.difference = object.difference ?? 0;
    message.relativeDifferencePercentage =
      object.relativeDifferencePercentage ?? 0;
    return message;
  },
};

function createBaseTourOperatorDifference(): TourOperatorDifference {
  return { oldTourOperator: "", newTourOperator: "" };
}

export const TourOperatorDifference = {
  encode(
    message: TourOperatorDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.oldTourOperator !== "") {
      writer.uint32(10).string(message.oldTourOperator);
    }
    if (message.newTourOperator !== "") {
      writer.uint32(18).string(message.newTourOperator);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.oldTourOperator = reader.string();
          break;
        case 2:
          message.newTourOperator = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorDifference {
    return {
      oldTourOperator: isSet(object.oldTourOperator)
        ? String(object.oldTourOperator)
        : "",
      newTourOperator: isSet(object.newTourOperator)
        ? String(object.newTourOperator)
        : "",
    };
  },

  toJSON(message: TourOperatorDifference): unknown {
    const obj: any = {};
    message.oldTourOperator !== undefined &&
      (obj.oldTourOperator = message.oldTourOperator);
    message.newTourOperator !== undefined &&
      (obj.newTourOperator = message.newTourOperator);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorDifference>
  ): TourOperatorDifference {
    const message = createBaseTourOperatorDifference();
    message.oldTourOperator = object.oldTourOperator ?? "";
    message.newTourOperator = object.newTourOperator ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
